import { render, staticRenderFns } from "./ph-edit.vue?vue&type=template&id=497a6cfd&scoped=true"
import script from "./ph-edit.vue?vue&type=script&lang=js"
export * from "./ph-edit.vue?vue&type=script&lang=js"
import style0 from "./ph-edit.vue?vue&type=style&index=0&id=497a6cfd&prod&scoped=true&lang=css"
import style1 from "./ph-edit.vue?vue&type=style&index=1&id=497a6cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a6cfd",
  null
  
)

export default component.exports